import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'g10-roster-trip-count-menu',
  templateUrl: './trip-report-menu.component.html',
  styles: [`.mat-toolbar {
    min-height: 50px !important;
    height: 50px !important;
    padding:0 6px !important;
}
.mat-toolbar-row {
    min-height: 50px !important;
    height: 50px !important;
}
.filterStickey{
    position: sticky;
    top: 0;
    z-index: 999;
    background: #e6e6e6;}`
],
})
export class TripReportMenuComponent implements OnInit {

 
  @Input() _activeMenu: string = '';
  @Output() routeTypeEmit = new EventEmitter();

  public routeType = '';
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}


  ngOnInit(): void {
  }

  pageNavigate(path, $event) {
    const urlPath = 'organization/transport-manager/reports/';
    setTimeout(() => {
      this.router.navigate([urlPath + path]);
    }, 10);
  }

}
